<template>
    <modal :name="modalName" transition="fade" top="0" width="700" height="auto" draggable="true"
        @before-open="beforeOpen" :adaptive="false">
        <div class="modal-container">
            <div class="create-modal-header ">
                <h3>Party Key</h3>
                <button @click=close>X</button>
            </div>
            <div class="modal-content">
                <div class="modal-create-data" style="margin-top: 0px;">
                    <div class="modal-create-data-item">
                        <p>Resident Name</p>
                        <input ref="resident-name" type="text" placeholder="Resident Name" class="modal-title"
                            v-model="residentUid" />
                    </div>
                    <div class="modal-create-data-section">
                        <p class="section-header">Visitor Information</p>
                        <div class="modal-create-data-item">
                            <p>Visitor Name</p>
                            <input ref="visitor-name" type="text" placeholder="Visitor Name" class="modal-title"
                                v-model="visitorName" />
                        </div>
                        <div class="modal-create-data-section">
                            <p class="section-header">Send Key By:</p>
                            <div class="modal-checkbox-item">
                                <input type="checkbox" />
                                <div class="modal-create-data-item">
                                    <p>Visitor Phone Number</p>
                                    <input ref="resident-name" type="text" placeholder="Visitor Phone Number"
                                        class="modal-title" v-model="residentUid" />
                                </div>
                            </div>
                            <div class="modal-checkbox-item">
                                <input type="checkbox" />
                                <div class="modal-create-data-item">
                                    <p>Visitor Email</p>
                                    <input ref="license-plate" type="text" placeholder="Visitor Email"
                                        class="modal-title" v-model="licensePlate" />
                                </div>
                            </div>
                        </div>
                        <div class="upload-attachment" style="display: flex; justify-content: center; margin-top: 8px;">
                            <button @click="() => handleUploadAttachments()" style="align-self: center;">
                                <b width="23" height="23" style="margin: 0px 8px;">+</b>
                                <b>Add Visitor</b>
                            </button>
                        </div>
                    </div>
                    <div class="modal-create-data-section">
                        <p class="section-header">Key Active Time</p>
                        <div class="modal-create-data-item">
                            <p>Start Time</p>
                            <input ref="visitor-expiration" type="date" placeholder="Vistor Expiration Time"
                                class="visitor-modal-title" v-model="visitorExpiration" />
                        </div>
                        <div class="modal-create-data-item">
                            <p>Expiration Time</p>
                            <input ref="visitor-expiration" type="date" placeholder="Vistor Expiration Time"
                                class="visitor-modal-title" v-model="visitorExpiration" />
                        </div>
                    </div>
                    <div class="modal-create-data-section">
                        <p class="section-header">Party Description</p>
                        <textarea placeholder="Type a message for your guests!"></textarea>
                    </div>

                </div>
            </div>
            <div class="modal-footer">
                <button @click="() => alert('Send Key')">Send Key</button>
            </div>
        </div>
    </modal>

</template>
<script>

import * as Constants from "../../js/constants.js";

const NAME = Constants.CREATE_PARTY_KEY_MODAL

export default {
    data() {
        return {
            modalName: NAME,
            firstName: "",
            lastName: "",
            residentUid: "",
            visitorName: "",
            businessName: "",
            visitorPhoneNumber: "",
            visitorEmail: "",
            licensePlate: "",
        }
    },
    methods: {
        show() {
            this.$modal.show(NAME);
        },
        close() {
            this.$modal.hide(NAME);
        },
        beforeOpen(event) {
            console.log('Before Opening...', event)
        },
    }
}
</script>
<style></style>